export default {
  reportMetadata: {
    titles: {
      360: 'Просмотр отчёта',
      '360-compare': 'Командный отчёт по результатам оценки 360',
      self: 'Просмотр отчёта',
      team: 'Просмотр отчёта',
      'ht-personal': 'Просмотр отчёта',
      'bh-personal-user': 'Личностное тестирование',
      'bh-personal-team': 'Сводный отчёт по личностным качествам участников команды',
    },
    exportTitles: {
      360: 'Отчёт 360',
      '360-compare': 'Командный отчёт 360',
      self: 'Отчёт по самооценке',
      team: 'Командный отчёт 360',
      'ht-personal': 'Личностное тестирование',
      'bh-personal-user': 'Личностное тестирование',
      'bh-personal-team': 'Сводный отчёт по личностным качествам участников команды',
    },
    shareReportTitle: 'Поделиться ссылкой на отчёт',
    withoutCalc: 'без расчётов',
    differenceScoresLegend: {
      labels: {
        less: 'Разница меньше или равна',
        more: 'Разница больше',
      },
    },
    scoresLegend: {
      labels: {
        low: 'Ниже нормы',
        middle: 'Соответствует норме',
        high: 'Выше нормы',
      },
    },
    deviationLegend: {
      labels: {
        low: 'ниже среднего по&nbsp;специализации',
        middle: 'совпадает со средним по&nbsp;специализации',
        high: 'выше среднего по&nbsp;специализации',
      },
    },
    potentialMatrix: {
      labels: {
        area: {
          underestimated: 'Скрытый потенциал',
          strengths: 'Опора команды',
          growthAreas: 'Зона развития',
          overestimated: 'Риск самооценки',
        },
        axis: {
          top: 'Все без самооценки',
          bottom: 'Все без самооценки',
          left: 'Низкая самооценка',
          right: 'Высокая самооценка',
        },
      },
      tooltips: {
        area: {
          underestimated:
            'Сотрудники с выраженными сильными сторонами, которых не осознают. Поддержка и признание помогут раскрыть потенциал. На верхних позициях списка — участники с наибольшим расхождением между внешней оценкой и самооценкой.',
          strengths:
            'Сотрудники, чьи сильные стороны признаны всеми. Потенциальные наставники и лидеры. На верхних позициях находятся участники с наиболее высокими оценками коллег и при этом высокой самооценкой.',
          growthAreas:
            'Сотрудники, которым необходима поддержка и развитие. Рекомендованы программы обучения, наставничества и повышения мотивации. На верхних позициях сотрудники, которые демонстрируют наименьшие оценки по самооценке и внешнему восприятию.',
          overestimated:
            'Завышенная самооценка относительно мнения других участников опроса. Основание для обратной связи и развития soft skills. На верхних позициях отображаются участники с наибольшей разницей между самооценкой и внешней оценкой.',
        },
      },
      noData: 'Никто из сотрудников не попал в эту зону',
    },
    teamList: {
      title: 'Состав команды',
      table: {
        headers: {
          name: 'ФИО',
        },
      },
    },
    stubs: {
      noScore: 'нет оценки',
      noScores: 'нет оценок',
    },
    errorMessages: {
      uploadDiagram: 'Не удалось подготовить некоторые диаграммы! Отчёт будет сформирован без них',
      getReportParams: 'Не удалось получить параметры отчёта',
    },
    360: {
      totalSection: {
        title: 'Итого по разделу',
      },
      changeCommentsParamsDialog: {
        title: 'Настроить комментарии',
        subtitle: 'Настройки будут сохранены для всех версий этого отчёта',
        labels: {
          hideAll: 'Отключить видимость всех комментариев',
          onlySupervisor: 'Оставить только комментарии руководителя',
          colleagues: 'Отключить видимость от коллег',
        },
        successMessage: 'Настройки комментариев успешно сохранены',
        errorMessage: 'Не удалось сохранить настройки комментариев',
      },
      changeVisibleExpertGroupsDialog: {
        title: 'Настроить группы',
        subtitle:
          'Настройки повлияют на отображение групп в таблице и на диаграмме общих результатов. При выгрузке в PDF и DOC будут выгружены только активные группы.',
        successMessage: 'Настройки групп успешно сохранены',
        errorMessage: 'Не удалось сохранить настройки групп',
      },
      changeFiltersDialog: {
        title: 'Настроить отчёт',
        subtitle: 'Выберите параметры отчёта',
        labels: {
          skillsTypes: 'Оцениваемые навыки',
          targetFields: 'Учёт оценок',
        },
      },
      user: {
        adequacySelf: {
          title: 'Адекватна ли самооценка сотрудника',
          table: {
            legendLabels: {
              differenceScores:
                'Шкала отображает разницу между самооценкой и оценкой остальных участников',
            },
          },
        },
        compareSelfOther: {
          title: 'Сравнение самооценки сотрудника с оценками остальных участников',
          groupFeedback: {
            title: 'Сильные стороны и зоны роста по мнению отдельных групп участников',
          },
          johari: {
            title: 'Результаты оценки в представлении Окно Джохари',
          },
        },
        compareSupervisorOther: {
          title: 'Совпадает ли оценка руководителя с мнением других участников',
          table: {
            legendLabels: {
              differenceScores:
                'Шкала отображает разрыв между оценкой руководителя и оценками других участников',
            },
          },
        },
        recommend: {
          title: 'Рекомендации по развитию',
          table: {
            noData: 'В данную категорию не попала ни одна компетенция',
          },
        },
        results: {
          title: 'Общие результаты',
          table: {
            legendLabels: {
              scores: 'Шкала оценок всех без самооценки (цвет цифр в таблицах соответствует шкале)',
              importance: 'Значения важности',
            },
          },
        },
        statistics: {
          title: 'Статистика участия',
          participantList: 'Списки участников',
          totalParticipants: 'Всего участников',
          passStatuses: {
            passed: 'Прошли опрос',
            notPassed: 'Не прошли опрос',
            rejected: 'Отказались от участия',
          },
        },
      },
      compare: {
        info: {
          title: 'Командный отчёт по результатам оценки 360',
          labels: {
            creationDate: 'Дата формирования отчёта',
            evalPeriod: 'Период оценки',
          },
        },
        potentialMatrix: {
          title: 'Матрица развития и потенциала',
          description:
            '<p>Сравнение самооценки сотрудника с остальными участниками оценки.</br>Матрица помогает выявить потенциальных наставников и лидеров, сотрудников со скрытым потенциалом, а также тех, кому необходима поддержка и развитие.</p>',
          headers: {
            self: 'Самооценка',
            experts: 'Все без самооценки',
            diff: 'Отклонение',
          },
        },
        skippedScores: {
          title: 'Пропущенные оценки',
          description:
            '<p>Индикаторы, по которым респонденты чаще всего не давали оценки. Высокий процент н/о указывает на то, что индикатор трудно оценить или он неактуален. Это помогает определить показатели, которые требуют пересмотра или уточнения, чтобы повысить качество оценки.</p>',
        },
        averageScore: {
          title: 'Среднее по специализации',
          description:
            '<p>Сравнение среднего балла сотрудника со средним баллом всех выбранных для анализа сотрудников по специализации.<br />Позволяет выявить сотрудников, находящихся выше или ниже среднего уровня в специализации для планирования стратегии обучения и развития, формирования кадрового резерва.</p>',
          table: {
            headers: {
              deviation: 'Отклонение',
              averageScore: 'Средний балл',
            },
          },
          legends: {
            labels: {
              scores: 'Шкала оценок',
              deviation: 'Шкала отклонений',
            },
            tooltips: {
              scores:
                'Цвет выделения среднего балла сотрудника на диаграмме ниже соответствует цветам этой шкалы.',
              deviation:
                'Цвет цифр отклонения среднего балла сотрудника от среднего балла по специализации на диаграмме ниже соответствует цветам этой шкалы.',
            },
          },
        },
        summaryScore: {
          title: 'Сводная матрица оценок участников',
          description:
            '<p>Отчёт формируется на основе последнего опроса 360° в установленный период.<br />Оценка рассчитывается как среднее арифметическое баллов, полученных от всех участников опроса.</p>',
          table: {
            headers: {
              competence: 'Блок/Компетенция',
              averageScore: 'Средний балл по специализации',
            },
            legendLabels: {
              scores: 'Шкала оценок',
            },
            tooltips: {
              scoresLegend:
                'Цвет цифр в таблицах соответствует шкале. Значения на шкале - это актуальные значения диапазонов шкалы, установленные на дату формирования отчёта.',
            },
          },
        },
        completeness: {
          title: 'Проверка полноты данных',
          progress: {
            title: 'Вовлеченность респондентов',
            table: {
              headers: {
                team: 'Команда',
                member: 'Участник',
                progress: '% завершения оценки',
                estimated: 'Оценили',
              },
            },
          },
        },
        strengthsGrowth: {
          title: 'Сильные стороны и зоны роста',
          description:
            '<p>Оценка рассчитывается как среднее арифметическое баллов выбранных участников.</p>',
          blocks: {
            strengths: {
              title: 'Сильные стороны',
              description:
                '<p>Навыки, в которых выбранные участники демонстрируют наивысшие результаты. Они могут стать основой для внутреннего наставничества.</p>',
            },
            growthAreas: {
              title: 'Зоны роста',
              description:
                '<p>Навыки, требующие внимания или дополнительной поддержки для эффективного выполнения задач, а также потенциальные точки развития, критичные для данной специализации.</p>',
            },
          },
        },
        userRating: {
          title: 'Максимальные и минимальные показатели',
          description:
            '<p>Участники с самыми высокими и самыми низкими итоговыми оценками по каждой компетенции.</p>',
          table: {
            headers: {
              competence: 'Блок/Компетенция',
              maxResult: 'Лучший результат',
              minResult: 'Слабый результат',
            },
          },
        },
      },
    },
    personal: {
      score: {
        legend: {
          motivation: {
            max: 'Полное соответствие',
            normal: 'Частичное соответствие',
            min: 'Полное несоответствие',
          },
          factors: {
            max: 'Полное соответствие',
            normal: 'Есть потенциал',
            min: 'Полное несоответствие',
          },
        },
        table: {
          headers: {
            indicator: 'Показатель',
            description: 'Описание',
          },
        },
      },
      factors: {
        title: 'Блок «Оценка соответствия профилю личностных и стоп-факторов»',
        descriptions: {
          team: '<p>Сформирован перечень основных значимых личностных факторов, которые необходимо оценивать по участникам команды при сборке команды и сравнения кандидатов.</p><p>При этом несколько факторов являются стоп-факторами – это факторы, при определенных значениях которых можно прогнозировать существенные риски для эффективной работы команды.</p><p>Далее будем оценивать личностные факторы по каждому участнику оценки.</p>',
          user: '<p>Сформирован перечень основных значимых личностных факторов, которые необходимо оценивать по участникам команды при сборке команды и сравнения кандидатов.</p>',
        },
        table: {
          titles: {
            team: 'Оценка соответствия профилю личностных и стоп-факторов отдельных участников',
            user: 'Оценка соответствия профилю личностных и стоп-факторов',
          },
          descriptions: {
            team: '<p>Соответствие профилю личностных и стоп-факторов будет оцениваться с помощью цветных маркеров и баллов. Маркеры позволяют оценить качественное соответствие профилю.</p><p>Баллы позволяют оценить степень соответствия для сравнения нескольких оцениваемых:</p><ul><li>Максимальный балл по каждому показателю мотивации – 4 балла</li><li>Максимальное соответствие профилю – 32 балла</li></ul>',
            user: '<p>Соответствие профилю личностных и стоп-факторов будет оцениваться с помощью цветных маркеров и баллов. Маркеры позволяют оценить качественное соответствие профилю.</p><ul><li>Максимальный балл по каждому показателю мотивации – 4 балла</li><li>Максимальное соответствие профилю – 32 балла</li></ul>',
          },
        },
      },
      motivation: {
        title: 'Блок «Оценка соответствия профилю мотивации»',
        descriptions: {
          team: '<p>Сформирован профиль мотивации, который отражает ожидания по ведущим/значимым мотивам в работе для успешного участника команды.</p><p>Относительно этого профиля будет оцениваться степень соответствия по каждому участнику оценки и по всем вариантам сборки команд.</p><p>Ожидается, что у участника команды должен быть выделен хотя бы один яркий мотив из профиля.</p>',
          user: '<p>Сформирован профиль мотивации, который отражает ожидания по ведущим/значимым мотивам в работе для успешного участника команды.</p><p>Ожидается, что у участника команды должен быть выделен хотя бы один яркий мотив из профиля.</p>',
        },
        table: {
          titles: {
            team: 'Оценка соответствия профилю мотивации отдельных участников',
            user: 'Оценка соответствия профилю мотивации',
          },
          descriptions: {
            team: '<p>Соответствие профилю мотивации будет оцениваться с помощью цветных маркеров и баллов. Маркеры позволяют оценить качественное соответствие профилю.</p><p>Баллы позволяют оценить степень соответствия для сравнения нескольких оцениваемых:</p><ul><li>Максимальный балл по каждому показателю мотивации – 4 балла</li><li>Максимальное соответствие профилю – 20 баллов</li></ul>',
            user: '<p>Соответствие профилю мотивации будет оцениваться с помощью цветных маркеров и баллов. Маркеры позволяют оценить качественное соответствие профилю.</p><ul><li>Максимальный балл по каждому показателю мотивации – 4 балла</li><li>Максимальное соответствие профилю – 20 баллов</li></ul>',
          },
        },
      },
      summary: {
        titles: {
          team: 'Выводы по итогам оценки команды',
          user: 'Выводы по итогам оценки',
        },
        factors: {
          title: 'Соответствие по личностным и стоп-факторам',
          table: {
            headers: {
              userName: 'ФИО',
              risks: 'Риски по личностным факторам',
            },
          },
          noData: 'Отсутствуют',
        },
        motivation: {
          title: 'Соответствие по мотивации',
          table: {
            headers: {
              userName: 'ФИО',
              risks: 'Риски по мотивации',
            },
          },
        },
      },
    },
  },
};
